import { FunctionComponent, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../ui/icon';
import { classnames } from '../../utils/classnames';
import { mediaScreen } from '../../utils/mediaScreen';

export const FAQ: FunctionComponent<{ items?: FAQItem[] }> = ({ items }) => {
  const [openQuestion, setOpenQuestion] = useState('');

  return (
    <Container>
      {items?.map((item) => {
        const isOpen = openQuestion === item.question;

        return (
          <Item
            key={item.question}
            onClick={() => setOpenQuestion(isOpen ? '' : item.question)}
            className={classnames({ open: isOpen })}
          >
            <div className="header">
              <p className="question">{item.question}</p>

              <Icon name={isOpen ? 'arrow-up' : 'arrow-down'} />
            </div>

            {isOpen && (
              <div
                className="answer fadeIn"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            )}
          </Item>
        );
      })}
    </Container>
  );
};

const Container = styled.div``;

const Item = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);

  &:last-of-type {
    border: none;
  }

  .header {
    display: flex;
    padding: 30px 0;
    cursor: pointer;

    .question {
      display: flex;
      font-size: 20px;
      color: white;
      font-weight: 400;
      flex: 1;
      margin: 0;
    }

    .icon {
      color: ${(props) => props.theme.colors.teal};
    }
  }

  .answer {
    animation-duration: 0.5s;
    padding-bottom: 30px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 16px;
    line-height: 1.7;

    li {
      margin: 15px 0;
    }

    table {
      margin-top: 30px;
    }

    table,
    td,
    th {
      border-collapse: collapse;
      font-size: 15px;
      border: 1px solid rgba(255, 255, 255, 0.3);
    }

    td,
    th {
      padding: 10px 15px;
    }

    th {
      text-transform: uppercase;
    }
  }

  &:hover,
  &.open {
    .question {
      color: ${(props) => props.theme.colors.teal};
    }
  }

  ${mediaScreen('xs', 'md')} {
    .header .question {
      font-size: 18px;
    }

    .answer {
      font-size: 14px;

      table,
      td,
      th {
        font-size: 13px;
      }
    }
  }
`;

export interface FAQItem {
  question: string;
  answer: string;
}
